import navigation from '../../../public-sdk/docs/navigation.json'
import { renderDocument } from '../../../public-sdk/tools/docs-renderer.mjs'
import type { SiteLocale } from '../types'

const markdown = import.meta.glob('../../../public-sdk/docs/*/*.md', { query: '?raw', import: 'default', eager: true }) as Record<string, string>
const slugs = new Set(navigation.articles.map(article => article.slug))
export const sdkNavigation = navigation

export function developerArticle(slug: string, locale: SiteLocale) {
  const article = navigation.articles.find(item => item.slug === slug)
  if (!article) return null
  const source = markdown[`../../../public-sdk/docs/${locale}/${slug}.md`]
  if (!source) throw new Error(`Missing developer document: ${locale}/${slug}`)
  return { ...article, ...renderDocument(source, href => {
    if (/^[^/#]+\.md(?:#.*)?$/.test(href)) {
      const [file, hash] = href.split('#')
      const target = file.slice(0, -3)
      return slugs.has(target) ? `/docs/developers/${target}${hash ? `#${hash}` : ''}` : null
    }
    return href.startsWith('#') || /^https?:\/\//.test(href) ? href : null
  }) }
}
